<script>
import overflowScroller from '@/components/view/overflow-scroller'
export default {
  components: {
    'overflow-scroller': overflowScroller
  },
  props: {
    to: {
      type: Object
    },
    route: {
      type: Object
    },
    videoId: {
      type: String,
      required: true
    },
    visibleList: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    videoListPosition: 0
  }),
  computed: {
    player () {
      return this.docs.video[this.videoId]
    },
    videoList () {
      const keys = Object.keys(this.docs.video)
        .sort((a, b) => a > b ? -1 : 1)
      const videoList = []
      keys.forEach(key => {
        videoList.push({
          ...this.docs.video[key],
          id: key
        })
      })
      return videoList
    }
  },
  mounted () {
    function indexOf (array, key, value) {
      if (!Array.isArray(array)) {
        return false
      }
      for (let i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return i
        }
      }
      return false
    }
    const index = indexOf(this.videoList, 'id', this.videoId)
    this.scrollTo(index)
  },
  methods: {
    scrollTo (index) {
      const padding = 16
      const containerWidth = this.$refs.videoList.clientWidth
      const itemWidth = this.$refs.video[0].clientWidth
      const targetWidth = itemWidth * this.$refs.video.length
      if (containerWidth >= targetWidth) {
        return
      }
      const targetPosition = itemWidth * index + (itemWidth - padding) / 2
      let xpos = 0
      if (containerWidth / 2 >= targetPosition) {
        xpos = 0
      } else if (targetWidth - containerWidth / 2 < targetPosition) {
        xpos = targetWidth - containerWidth
      } else {
        xpos = targetPosition - containerWidth / 2
      }
      this.videoListPosition = Math.round(xpos)
    },
    next () {
      this.scrollTo(this.$refs.video.length - 1)
    },
    prev () {
      this.scrollTo(0)
    }
  }
}
</script>

<template>
  <div class="gp-video-player">
    <div class="container">
      <div class="player-wrapper">
        <iframe
          id="ytplayer"
          type="text/html"
          width="100%"
          height="100%"
          frameborder="0"
          allowfullscreen
          :src="player.url"
        ></iframe>
      </div>
      <div
        v-show="visibleList"
        class="video-list"
      >
        <overflow-scroller :position="videoListPosition">
          <ul ref="videoList">
            <li
              class="video is-small"
              v-for="video in videoList"
              ref="video"
              :key="video.id"
              :class="{current: video.id === videoId}"
            >
              <router-link
                :to="{hash: '#' + video.id}"
                replace
              >
                <figure>
                  <img
                    :src="video.image"
                    :alt="video.title"
                  >
                  <span class="icon play"><i></i></span>
                </figure>
                <div class="title has-text-align-center is-size-4 is-size-6-mobile has-text-weight-bold">
                  <span>{{ video.title }}</span>
                </div>
              </router-link>
            </li>
          </ul>
        </overflow-scroller>
        <div class="controller is-hidden-mobile">
          <div class="left" @click="prev">
            <img src="@/assets/icon-player-left-arrow.svg">
          </div>
          <div class="right" @click="next">
            <img src="@/assets/icon-player-right-arrow.svg">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gp-video-player {
  background-color: $red-background;
  pointer-events: none;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $white;
  * {
    pointer-events: auto;
  }
  .video-list {
    position: relative;
    margin-top: 2.5rem;
    width: 100%;
    @include is-mobile {
      width: 100vw;
      padding: 0 1rem;
    }
    ul {
      width: 100%;
      display: flex;
      align-items: flex-start;
      li.video {
        padding-right: 1rem;
        .title {
          padding: .375rem;
        }
        figure {
          background-color: $black;
        }
      }
      .video.current {
        .title {
          background-color: $black;
        }
        figure {
          img {
            opacity: 1;
          }
          &:after {
            display: none;
          }
        }
      }
    }
    .controller {
      .left, .right {
        position: absolute;
        top: 3.5rem;
        width: 3rem;
        height: 3rem;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .left {
        left: 0;
      }
      .right {
        right: 0;
      }
    }
  }

  @include is-mobile {
    .container {
      width: 100%;
      max-width: 30rem;
    }
    .player-wrapper {
      width: auto;
      height: 15rem;
      margin: .5rem;
    }
    .video-list {
      li.video {
        figure {
          width: 12.5rem;
          height: 7rem;
        }
      }
    }
  }
  @include is-not-mobile {
    min-width: $min-width;
    min-height: 800px;
    .container {
      max-width: 56.25rem;
    }
    .player-wrapper {
      width: 900px;
      height: 506px;
    }
    .video-list {
      height: 14rem;
      .video {
        figure {
          width: 18rem;
          height: 10rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/video-player.vue